import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { XCircle, ArrowLeft, RefreshCw } from "lucide-react";

const PaymentCanceled = () => {
  return (
    <div 
      className="min-h-screen flex items-center justify-center px-4 py-20"
      style={{
        background: "linear-gradient(180deg, #000000 0%, #0a0a0f 50%, #000000 100%)",
      }}
    >
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.6 }}
        className="w-full max-w-2xl text-center"
      >
        {/* Cancel Icon */}
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.2, type: "spring", stiffness: 200 }}
          className="mb-6"
        >
          <XCircle 
            size={80} 
            className="mx-auto"
            style={{ color: "#EF4444" }}
          />
        </motion.div>

        {/* Card */}
        <div 
          className="rounded-3xl p-8 md:p-12"
          style={{
            background: "linear-gradient(135deg, rgba(255, 255, 255, 0.07) 0%, rgba(255, 255, 255, 0.03) 100%)",
            backdropFilter: "blur(20px)",
            border: "1px solid rgba(255, 255, 255, 0.15)",
            boxShadow: "0 0 40px rgba(0, 0, 0, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.1)",
          }}
        >
          <h1 
            className="text-4xl md:text-5xl font-bold mb-4"
            style={{
              fontFamily: "serif",
              color: "#FFFFFF",
            }}
          >
            Payment Canceled
          </h1>
          
          <p 
            className="text-lg md:text-xl mb-8"
            style={{ 
              color: "rgba(255, 255, 255, 0.7)",
              fontFamily: "'Bensoon', sans-serif",
            }}
          >
            Your payment was canceled. No charges were made to your account.
          </p>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/pricing">
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="w-full sm:w-auto px-8 py-3 rounded-xl font-medium transition-all duration-300 flex items-center justify-center gap-2"
                style={{
                  background: "#E67E22",
                  color: "#000000",
                  fontFamily: "'Bensoon', sans-serif",
                  boxShadow: "0 4px 20px rgba(230, 126, 34, 0.4)",
                }}
              >
                <RefreshCw size={20} />
                Try Again
              </motion.button>
            </Link>

            <Link to="/courses">
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="w-full sm:w-auto px-8 py-3 rounded-xl font-medium transition-all duration-300 flex items-center justify-center gap-2"
                style={{
                  background: "rgba(255, 255, 255, 0.05)",
                  border: "1px solid rgba(255, 255, 255, 0.2)",
                  color: "#FFFFFF",
                  fontFamily: "'Bensoon', sans-serif",
                }}
              >
                <ArrowLeft size={20} />
                Browse Courses
              </motion.button>
            </Link>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default PaymentCanceled;
